import moment from 'moment';
const DASH = '—';
const TABLE_DATE_FORMAT = 'DD/MM/YY';

/** Where a bill entered the system, keyed by the service's BillSource values. */
export const BILL_SOURCES = {
  api: 'API',
  billsDashboard: 'Bills Dashboard',
  email: 'Email',
  integration: 'Integration',
  propertyAllocation: 'Property Allocation',
  scrape: 'Utility Portal'
};
const BILL_SOURCE_BY_API_VALUE = {
  Api: BILL_SOURCES.api,
  Email: BILL_SOURCES.email,
  Integration: BILL_SOURCES.integration,
  Manual: BILL_SOURCES.propertyAllocation,
  Portal: BILL_SOURCES.billsDashboard,
  Scrape: BILL_SOURCES.scrape
};

/** Table labels for the service's BillStatus values, in pipeline order. */
export const BILL_STATUSES = {
  pending: 'Pending',
  processing: 'Processing',
  extracted: 'Extracted',
  validated: 'Validated',
  needsProperty: 'Needs property',
  failed: 'Failed'
};
const BILL_STATUS_BY_API_VALUE = {
  Pending: BILL_STATUSES.pending,
  Processing: BILL_STATUSES.processing,
  Extracted: BILL_STATUSES.extracted,
  Validated: BILL_STATUSES.validated,
  NeedsProperty: BILL_STATUSES.needsProperty,
  Failed: BILL_STATUSES.failed
};
export const formatTableDate = value => {
  if (!value) return DASH;
  const parsed = moment(value);
  return parsed.isValid() ? parsed.format(TABLE_DATE_FORMAT) : DASH;
};

/**
 * Both ends of the period are billed, so 1–31 March is 31 days and not 30. Times of day are dropped
 * first, otherwise a period stamped at different hours loses or gains a day.
 */
export const getServiceDayCount = (start, end) => {
  if (!(start !== null && start !== void 0 && start.isValid()) || !(end !== null && end !== void 0 && end.isValid())) return DASH;
  return Math.max(end.clone().startOf('day').diff(start.clone().startOf('day'), 'days') + 1, 1);
};

/** Maps a bill from the company bills endpoint onto the shape the table renders. */
export const mapCompanyBillToRow = bill => {
  var _bill$allocation$done, _bill$allocation, _bill$allocation$tota, _bill$allocation2, _bill$appfolioPush$do, _bill$appfolioPush, _bill$appfolioPush$to, _bill$appfolioPush2;
  const serviceStart = bill.serviceStartDate ? moment(bill.serviceStartDate) : null;
  const serviceEnd = bill.serviceEndDate ? moment(bill.serviceEndDate) : null;
  const hasServicePeriod = (serviceStart === null || serviceStart === void 0 ? void 0 : serviceStart.isValid()) && (serviceEnd === null || serviceEnd === void 0 ? void 0 : serviceEnd.isValid());
  return {
    id: bill.billId,
    /** Real bills can be fetched by id, so their details view is reachable. */
    canViewDetails: true,
    fileName: bill.fileName || DASH,
    status: BILL_STATUS_BY_API_VALUE[bill.extractStatus] || bill.extractStatus || BILL_STATUSES.pending,
    statusTooltip: bill.extractStatus || '',
    billSource: BILL_SOURCE_BY_API_VALUE[bill.source] || bill.source || DASH,
    allocation: {
      done: (_bill$allocation$done = (_bill$allocation = bill.allocation) === null || _bill$allocation === void 0 ? void 0 : _bill$allocation.done) !== null && _bill$allocation$done !== void 0 ? _bill$allocation$done : 0,
      total: (_bill$allocation$tota = (_bill$allocation2 = bill.allocation) === null || _bill$allocation2 === void 0 ? void 0 : _bill$allocation2.total) !== null && _bill$allocation$tota !== void 0 ? _bill$allocation$tota : 0
    },
    appfolioPush: {
      done: (_bill$appfolioPush$do = (_bill$appfolioPush = bill.appfolioPush) === null || _bill$appfolioPush === void 0 ? void 0 : _bill$appfolioPush.done) !== null && _bill$appfolioPush$do !== void 0 ? _bill$appfolioPush$do : 0,
      total: (_bill$appfolioPush$to = (_bill$appfolioPush2 = bill.appfolioPush) === null || _bill$appfolioPush2 === void 0 ? void 0 : _bill$appfolioPush2.total) !== null && _bill$appfolioPush$to !== void 0 ? _bill$appfolioPush$to : 0
    },
    // The list endpoint does not carry utilities yet, so the column stays empty for real bills.
    utilityIcons: [],
    utilityTypes: [],
    propertiesLines: bill.properties || [],
    account: bill.accountNumber || DASH,
    provider: bill.provider || DASH,
    servicePeriod: hasServicePeriod ? "".concat(serviceStart.format(TABLE_DATE_FORMAT), " - ").concat(serviceEnd.format(TABLE_DATE_FORMAT)) : DASH,
    days: getServiceDayCount(serviceStart, serviceEnd),
    amount: typeof bill.amount === 'number' ? bill.amount : null,
    // Only the invoice date comes back today, not the invoice number.
    invoiceNumber: DASH,
    dueDate: formatTableDate(bill.dueDate),
    dateUploaded: formatTableDate(bill.acquiredAt)
  };
};